import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap, shareReplay, switchMap, filter } from 'rxjs/operators';

import { environment } from '@app/env-service';

interface TenantInfo {
  id :number;
  name :string;
  enterprise_login_url :any;
  enterprise_logout_url :any;
}

@Injectable({
  providedIn: 'root',
})
export class TenantInfoService {
  #url :string;
  #infoRequested :boolean = false;

  readonly #_data = new BehaviorSubject<TenantInfo | null>(null);
  #fetchTenantInfo$ :Observable<TenantInfo>;

  constructor(private http :HttpClient) {
    this.init();
  }

  async init() {
    await environment.init();
    this.#url = environment.url;

    this.#fetchTenantInfo$ = this.http.get<TenantInfo>(`${this.#url}/info`).pipe(
      map((response :any) => ({
        id: response.id,
        name: response.name,
        enterprise_login_url: response.enterprise_login_url,
        enterprise_logout_url: response.enterprise_logout_url,
      })),
      tap((tenantInfo :TenantInfo) => {
        this.#_data.next(tenantInfo);
      }),
      shareReplay(1),
    );
  }

  getTenantInfo() :Observable<TenantInfo> {
    if (!this.#infoRequested) {
      this.#infoRequested = true;
      this.#fetchTenantInfo$.subscribe();
    }

    return this.#_data.asObservable().pipe(
      switchMap((info) => (info ? of(info) : this.#fetchTenantInfo$)),
      filter((info) :info is TenantInfo => info !== null),
    );
  }
}
